<template>
    <div v-if="timer.status" :class="bodyClass">
        <div v-if="size === 'sm'" class="dash-countdown">
            <div class="countdownlist">
                <div class="countdownlist-item">
                    <div class="count-title">Days</div>
                    <div class="count-num"> {{ timer.days }}</div>
                </div>
                <div class="countdownlist-item">
                    <div class="count-title"><span class="d-sm-none">Hrs</span><span class="d-none d-sm-inline">Hours</span></div>
                    <div class="count-num"> {{ timer.hours }}</div>
                </div>
                <div class="countdownlist-item">
                    <div class="count-title"><span class="d-sm-none">Mins</span><span class="d-none d-sm-inline">Minutes</span></div>
                    <div class="count-num"> {{ timer.minutes }}</div>
                </div>
                <div class="countdownlist-item">
                    <div class="count-title"><span class="d-sm-none">Secs</span><span class="d-none d-sm-inline">Seconds</span></div>
                    <div class="count-num"> {{ timer.seconds }}</div>
                </div>
            </div>
        </div>
        <div v-else class="card mb-0 overflow-hidden">
            <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="card-title mb-0">{{ title }}</h5>
            </div>
            <div class="card-body">
                <div  class="dash-countdown">
                    <div class="countdownlist">
                        <div class="countdownlist-item">
                            <div class="count-title">Days</div>
                            <div class="count-num"> {{ timer.days }}</div>
                        </div>
                        <div class="countdownlist-item">
                            <div class="count-title"><span class="d-sm-none">Hrs</span><span class="d-none d-sm-inline">Hours</span></div>
                            <div class="count-num"> {{ timer.hours }}</div>
                        </div>
                        <div class="countdownlist-item">
                            <div class="count-title"><span class="d-sm-none">Mins</span><span class="d-none d-sm-inline">Minutes</span></div>
                            <div class="count-num"> {{ timer.minutes }}</div>
                        </div>
                        <div class="countdownlist-item">
                            <div class="count-title"><span class="d-sm-none">Secs</span><span class="d-none d-sm-inline">Seconds</span></div>
                            <div class="count-num"> {{ timer.seconds }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else class="countdownlist" :class="bodyClass">
        <div class="countdownlist-item w-100">
            <div class="count-title">Timer status</div>
            <div class="count-num"> Time has elapsed</div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        title:{
            type: String,
            default: "Start time"
        },
        bodyClass:{
            type: String,
            default: ""
        },
        size: {
            type: String,
            default: ""
        },
        deadline:{
            type: String,
            required: true
        }
    },
    data(){
        return {
           timer: {
                days: "",
                hours: "",
                minutes: "",
                seconds: "",
                status: false,
            },
            interval: "",
        }
    },
    methods:{
        timerCount(){
            var now = new Date().getTime();
            var deadlineTime = new Date(this.deadline).getTime();
            var distance = deadlineTime - now;
            if( distance > 0 ){
                this.calcTime(distance);
            } else {
                this.timer.status = false;
                clearInterval(this.interval);
                return;
            }
        },
        calcTime(dist){
            // Time calculations for days, hours, minutes and seconds
            this.timer.days = Math.floor(dist / (1000 * 60 * 60 * 24))
            this.timer.hours = this.toSlice(Math.floor((dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)))
            this.timer.minutes = this.toSlice(Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60)))
            this.timer.seconds = this.toSlice(Math.floor((dist % (1000 * 60)) / 1000))
        },
        toSlice(t){
            return ('0' + t).slice(-2)
        },
        timerIgniter(){
            if(!this.deadline) { return }
            this.timer.status = true
            this.timerCount()
            this.interval = setInterval(() => {
                this.timerCount()
            }, 1000)
        },
    },
    mounted(){
        this.timerIgniter()
    },
    // beforeDestroy(){
    //     clearInterval(this.interval)
    // },
    beforeUnmount(){ // Use beforeUnmount for Vue 3
        clearInterval(this.interval);
    }
}
</script>

<style>

.countdownlist {
    text-align: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    gap: 24px
}

.countdownlist .countdownlist-item {
    width: 25%
}

.countdownlist .countdownlist-item:last-of-type .count-num::after {
    display: none
}

.countdownlist .count-title {
    font-size: 13px;
    font-weight: 500;
    display: block;
    margin-bottom: 8px;
    color: rgba(var(--bs-body-color-rgb),.5);
    text-transform: uppercase
}

.countdownlist .count-num {
    background-color: var(--bs-light);
    padding: 12px 8px;
    position: relative;
    border-radius: var(--bs-border-radius);
    -webkit-box-shadow: 0 3px 3px rgba(56,65,74,.1);
    box-shadow: 0 3px 3px rgba(56,65,74,.1);
    font-weight: 600;
    font-size: 22px
}

@media (max-width: 575.98px) {
    .countdownlist .count-num {
        font-size:18px
    }
}

.countdownlist .count-num::after {
    content: ":";
    font-size: 20px;
    position: absolute;
    right: -16px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    color: var(--bs-body-color)
}

</style>